import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import {StorageService} from './storage.service';
import {URL_PORTAL_SERVICOS_API} from "../util/constants";

@Injectable()
export class ImunizacaoService {

  constructor(
    private http: HttpClient,
  ) { }

  getDatas(params): Observable<any> {
    let url = `${URL_PORTAL_SERVICOS_API}/arquivo-imunizacao/datas?`;
    if (params.idPortfolio) {
      url = `${url}idPortfolio=${params.idPortfolio}&`;
    }
    if (params.permissao) {
      url = `${url}permissao=${params.permissao}&`;
    }

    return this.http.get(url);
  }

  getArquivosMes(params): Observable<any> {
    let url = `${URL_PORTAL_SERVICOS_API}/arquivo-imunizacao/arquivos-mes?`;
    if (params.idPortfolio) {
      url = `${url}idPortfolio=${params.idPortfolio}&`;
    }
    if (params.ano) {
      url = `${url}ano=${params.ano}&`;
    }
    if (params.mes) {
      url = `${url}mes=${params.mes}&`;
    }
    if (params.permissao) {
      url = `${url}permissao=${params.permissao}&`;
    }

    return this.http.get(url);
  }

  getHistoricoArquivoImunizacao(idArquivo): Observable<any> {
    return this.http.get(`${URL_PORTAL_SERVICOS_API}/arquivo-imunizacao/arquivos/historico/${idArquivo}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/imunizacao.service.ts